"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingApprovalsResponse = exports.PendingApprovalItem = exports.PendingApprovalsQueryParams = exports.ApprovePayoutResponse = exports.ApprovePayoutBody = exports.ApprovePayoutParams = void 0;
const typebox_1 = require("@sinclair/typebox");
/**
 * Approve Payout Transport Types
 *
 * These types define the API contract for payout approval operations.
 */
// Params
exports.ApprovePayoutParams = typebox_1.Type.Object({
    approvalID: typebox_1.Type.String({ format: 'uuid' }),
});
// Body
exports.ApprovePayoutBody = typebox_1.Type.Object({
    decision: typebox_1.Type.Union([typebox_1.Type.Literal('APPROVE'), typebox_1.Type.Literal('REJECT')]),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
});
// Response
exports.ApprovePayoutResponse = typebox_1.Type.Object({
    approvalID: typebox_1.Type.String({ format: 'uuid' }),
    status: typebox_1.Type.Union([typebox_1.Type.Literal('APPROVED'), typebox_1.Type.Literal('REJECTED')]),
    approvedBy: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    approvedAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    rejectedBy: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    rejectedAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    rejectionReason: typebox_1.Type.Optional(typebox_1.Type.String()),
});
// Pending Approvals Query
exports.PendingApprovalsQueryParams = typebox_1.Type.Object({
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    limit: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 1, maximum: 100, default: 50 })),
    offset: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0, default: 0 })),
});
// Pending Approval Item
exports.PendingApprovalItem = typebox_1.Type.Object({
    approvalID: typebox_1.Type.String({ format: 'uuid' }),
    payableID: typebox_1.Type.String({ format: 'uuid' }),
    invoiceID: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    vendorName: typebox_1.Type.String(),
    amount: typebox_1.Type.Integer(),
    requestedAt: typebox_1.Type.String(),
    requestedBy: typebox_1.Type.String({ format: 'uuid' }),
    requestedPaymentMethod: typebox_1.Type.Union([typebox_1.Type.Literal('ACH'), typebox_1.Type.Literal('CREDIT_CARD')]),
    requiresDualApproval: typebox_1.Type.Boolean(),
    invoiceNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    dueDate: typebox_1.Type.Optional(typebox_1.Type.String()),
});
// Pending Approvals Response
exports.PendingApprovalsResponse = typebox_1.Type.Object({
    approvals: typebox_1.Type.Array(exports.PendingApprovalItem),
    total: typebox_1.Type.Integer(),
    limit: typebox_1.Type.Integer(),
    offset: typebox_1.Type.Integer(),
});
//# sourceMappingURL=approval-transport.js.map